import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  numberOfPlants: 0
};

export function PlantTankReducer(
  state = { plantTanks: [] },
  action
) {
  let currentPlantTank;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_PLANT_TANK" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("plantTanks")
      ) {
        currentPlantTank =
          state.protocolSection.scene.apparatus.plantTanks[
            findIndex(state.protocolSection.scene.apparatus.plantTanks, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_PLANT_TANK":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("plantTanks")) {
        protocolSection.scene.apparatus.plantTanks = [
          ...protocolSection.scene.apparatus.plantTanks,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.plantTanks = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "SET_PLANTS_IN_SCENE":
      //Payload = {inScene}
      let currentPlantTank2 = protocolSection.scene.apparatus.plantTanks[findIndex(state.protocolSection.scene.apparatus.plantTanks, { id: 1 })];

      if(action.payload.inScene){
        currentPlantTank2.numberOfPlants = currentPlantTank2.numberOfPlants + 1
      } else {
        currentPlantTank2.numberOfPlants = currentPlantTank2.numberOfPlants - 1
      }

      protocolSection.scene.apparatus.plantTanks[findIndex(state.protocolSection.scene.apparatus.plantTanks, { id: 1 })] = currentPlantTank2;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('plantTanks')) {
        protocolSection.scene.apparatus.plantTanks =
          action.payload.lastState.scene.apparatus.plantTanks;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
